import {
    Box,
    Heading,
    Spinner,
    Text,
} from "@chakra-ui/react";
import { useEffect, useMemo, useState } from "react";

import { fetchAllParts } from "../Api/parts.service";
import PartsGrid from "../components/PartsGrid";
import PartsFilters, {
    PartsFilterState,
} from "../components/PartsFilters";
import { applyPartFilters } from "../utils/applyPartFilters";
import { Part } from "../Types/part";

const PartsCatalogPage = () => {
    const [parts, setParts] = useState<Part[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const [filters, setFilters] = useState<PartsFilterState>({
        oem: "all",
        inStockOnly: false,
    });

    useEffect(() => {
        const loadParts = async () => {
            try {
                const data = await fetchAllParts();
                setParts(data);
            } catch {
                setError("Failed to load parts catalog.");
            } finally {
                setLoading(false);
            }
        };

        loadParts();
    }, []);

    const filteredParts = useMemo(
        () => applyPartFilters(parts, filters),
        [parts, filters]
    );

    return (
        <Box>
            <Heading mb={4}>Car Parts Catalog</Heading>

            <PartsFilters
                filters={filters}
                onChange={setFilters}
            />

            {loading && <Spinner />}

            {error && (
                <Text mt={4} color="red.500">
                    {error}
                </Text>
            )}

            {!loading && !error && (
                <PartsGrid parts={filteredParts} />
            )}
        </Box>
    );
};

export default PartsCatalogPage;
